// eslint-disable-next-line import/prefer-default-export
export const FREE_ACCESS_GROUP = {
  code: 'free',
  name: 'Free Access',
};

export const DEFAULT_FORM_VALUES = {
  name: '',
  code: '',
};
